const PT = require("prop-types");
const React = require("react");
const moment = require("moment");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const CodeValidationBox = require("./CodeValidationBox");
const _ = require("lodash");
const STUDENT_LIMIT = require("../../../shared/Constants")
	.MAX_SUBSCRIPTIONS_FOR_PARENT;
const StoreUtil = require("../../../shared/StoreUtil");
const {UserPlus, SquarePen} = require("lucide-react");
const CopyTable = require("../data/CopyTable");
const displayNameErrorCopy = CopyTable.getFormInvalidCopy("displayName");
const styles = require("./styles/PageRedeemSubscription.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "RedeemSubscriptionStudentsLoggedIn",

		propTypes: {
			cart: PT.object.isRequired,
			onContinue: PT.func.isRequired,
			account: PT.object,
			dispatch: PT.func.isRequired, // Injected by HOCs
		},

		getInitialState: function() {
			return {
				students: [], // all students in the account (includes new student)
				code: "", // code to redeem
				checkCodesStatus: "", // status of code validation (set by CodeValidationBox)
				parentAccountHasLoaded: false, // whether the parent account has loaded
				numberOfExistingStudents: 0, // number of existing students in the account
				showAddStudent: true, // whether to show the form to add a new student
				newStudentName: "", // name of the new student (as it's being typed)
			};
		},

		statics: {
			getDerivedStateFromProps: function(props, state) {
				if (
					!state.parentAccountHasLoaded &&
					_.get(props, "account.load") === "done"
				) {
					const accountStudents = _.get(props, "account.students", []);
					const preselectedStudent = _.get(
						props,
						"cart.redeemSubscriptionStudentData",
						{}
					);
					const students = _.map(accountStudents, a => ({
						name: a.displayName,
						username: a.username,
						subscription: a.subscription,
						planType: a.subscription.planType,
						active: a.subscription.active,
						expiresAt: a.subscription.expiresAt,
						userID: a.userID,
						isSelected:
							a.displayName === preselectedStudent.name
								? preselectedStudent.isSelected
								: false,
						isNewStudent: false,
					}));
					if (preselectedStudent.isNewStudent) {
						students.push({
							name: preselectedStudent.name,
							isSelected: true,
							isNewStudent: true,
						});
					}
					return {
						students,
						numberOfExistingStudents: accountStudents.length,
						parentAccountHasLoaded: true,
						showAddStudent: preselectedStudent.isNewStudent ? false : true,
						newStudentName: preselectedStudent.isNewStudent
							? preselectedStudent.name
							: "",
					};
				}
				return {};
			},
		},

		handleCodeValidationStatusChange: function(status, code) {
			this.setState({checkCodesStatus: status, code: code});
		},

		handleStudentSelection: function(student) {
			const updatedStudents = this.state.students.map(s => ({
				...s,
				isSelected: s.name === student.name ? !s.isSelected : false,
			}));
			this.setState({students: updatedStudents});
		},

		handleAddNewStudent: function(event) {
			event.preventDefault(); // Prevent form submission refresh

			const updatedStudents = this.state.students.map(s => ({
				...s,
				isSelected: false,
			}));

			const newStudent = {
				name: this.state.newStudentName,
				isSelected: true,
				isNewStudent: true,
			};

			this.setState({
				students: updatedStudents.concat([newStudent]),
				showAddStudent: false,
			});
		},

		handleEditNewStudent: function() {
			const updatedStudents = this.state.students.filter(
				student => !student.isNewStudent
			);
			this.setState({
				students: updatedStudents,
				showAddStudent: true,
			});
		},

		// Saves subscription data in the vault and continue to next step
		saveAndContinue: function() {
			this.props.dispatch({
				type: AT.UPDATE_REDEEM_CODES_STUDENT_DATA,
				studentData: _.find(this.state.students, s => s.isSelected),
				code: this.state.code,
			});
			this.props.onContinue();
		},

		renderStudents: function() {
			const {students} = this.state;
			const eligibleAccounts = _.map(students, (student, i) => {
				// Get student name
				const studentNameEl = (
					<div className={styles.studentNameEl}>{student.name}</div>
				);

				// Get expiresAt if it exists
				const subscription = _.get(student, "subscription", {});
				const expiresAt =
					subscription.active &&
					!subscription.expiredAt &&
					subscription.expiresAt
						? moment(subscription.expiresAt).format("M/D/YY")
						: null;
				const expiresAtEl = expiresAt ? (
					<div className={styles.expiresAtEl}>
						Currently Enrolled (expires {expiresAt})
					</div>
				) : null;

				// Edit button
				const editStudentButtonEl = student.isNewStudent ? (
					<div
						className={styles.editStudentButtonEl}
						onClick={this.handleEditNewStudent}
					>
						Edit Student
						<SquarePen size={14} />
					</div>
				) : null;

				return (
					<div
						key={"existingStudent" + i}
						className={
							student.isSelected
								? styles.selectedIndividualStudentContainer
								: styles.individualStudentContainer
						}
					>
						<input
							type="radio"
							name="studentSelection"
							value={student.userID}
							id={`student-${student.name}`}
							checked={student.isSelected}
							onChange={() => this.handleStudentSelection(student)}
						/>
						<label
							htmlFor={`student-${student.name}`}
							className={styles.studentLabel}
						>
							{studentNameEl}
							{expiresAtEl}
							{editStudentButtonEl}
						</label>
					</div>
				);
			});
			return eligibleAccounts;
		},

		renderAddStudentForm: function() {
			if (
				this.state.numberOfExistingStudents < STUDENT_LIMIT &&
				this.state.showAddStudent
			) {
				const studentDisplayNames = [
					..._.map(this.state.students, s => s.name),
					this.state.newStudentName,
				];
				const nameError = StoreUtil.isBadNameInSubscriptions(
					studentDisplayNames,
					this.state.newStudentName
				);
				return (
					<div>
						<div className={styles.addStudentContainer}>
							<div className={styles.inputWrapper}>
								<input
									type="text"
									value={this.state.newStudentName}
									onChange={e =>
										this.setState({newStudentName: e.target.value})
									}
									name="studentName"
									placeholder="Name or nickname"
								/>
							</div>
							<button
								className={styles.addStudentButton}
								onClick={this.handleAddNewStudent}
								disabled={nameError}
							>
								<UserPlus size={14} />
								Add Student
							</button>
						</div>
						<div className={styles.statusMessage}>
							{this.state.newStudentName && nameError && (
								<div className={styles.errorMessage}>
									{displayNameErrorCopy[nameError]}
								</div>
							)}
						</div>
					</div>
				);
			}
		},

		handleKeyDown: function(e) {
			if (
				e.key === "Enter" &&
				this.state.checkCodesStatus === "complete" &&
				this.state.students.some(student => student.isSelected)
			) {
				e.preventDefault();
				this.saveAndContinue();
			}
		},

		render: function() {
			const studentsEl = this.renderStudents();
			const addStudentFormEl = this.renderAddStudentForm();
			return (
				<div
					className={styles.sectionWrapper}
					onKeyDown={this.handleKeyDown}
					tabIndex="0"
				>
					<h2 className={styles.title}>Select a Student</h2>
					<div className={styles.bodyText}>
						Select{" "}
						{this.state.numberOfExistingStudents < STUDENT_LIMIT
							? "or add "
							: ""}
						a student account to apply a discount to. You'll be able to add
						another student after redeeming your code.
					</div>
					<div className={styles.allStudentsContainer}>
						{studentsEl}
						{addStudentFormEl}
					</div>
					<CodeValidationBox
						cart={this.props.cart}
						checkCodesStatus={this.state.checkCodesStatus}
						onValidationStatusChange={this.handleCodeValidationStatusChange}
					/>
					<div className={styles.applyCodeBtnContainer}>
						<button
							className={styles.primaryButton}
							type="submit"
							disabled={
								this.state.checkCodesStatus !== "complete" ||
								!this.state.students.some(student => student.isSelected)
							}
							onClick={() => {
								this.saveAndContinue();
							}}
						>
							Apply Code
						</button>
					</div>
				</div>
			);
		},
	})
);
